import type { AgentSessionStreamService } from './AgentSessionStreamService';

/**
 * Calls `onDrop` once per dropped connection: on the first `reconnecting` status, and not again until
 * the stream has re-opened. A run may finish while the socket is down, so a consumer uses this to
 * re-sync from the authoritative source once per gap rather than on every backoff retry. Cleanup is
 * driven by the signal, as with the service's own subscriptions.
 */
export const subscribeStreamDrops = (
  service: Pick<AgentSessionStreamService, 'subscribeStatus' | 'getConnectionStatus'>,
  onDrop: () => void,
  options: { signal: AbortSignal }
): void => {
  let handledDrop = false;
  service.subscribeStatus(() => {
    const status = service.getConnectionStatus();
    if (status === 'reconnecting' && !handledDrop) {
      handledDrop = true;
      onDrop();
    } else if (status === 'open') {
      handledDrop = false;
    }
  }, options);
};
